// An empty breakdown is meaningful only for a verified, not-yet-locked draft.
// It is not permission to replace missing live/settled player statistics.
export function isVerifiedUnscoredDraft(input: {
  authority: string
  locked: boolean
  deadlineAt: string | null
  observedAt: number
  statCount: number
  totals: readonly number[]
}): boolean {
  const deadline = input.deadlineAt ? Date.parse(input.deadlineAt) : NaN
  return (
    input.authority === 'pre_deadline' &&
    !input.locked &&
    Number.isFinite(input.observedAt) &&
    Number.isFinite(deadline) &&
    input.observedAt < deadline &&
    input.statCount === 0 &&
    input.totals.length === 5 &&
    input.totals.every((value) => value === 0)
  )
}
